var _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.2809,
    fill: "url(#paint0_linear_684_3215)",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_684_3215)",
    strokeWidth: 0.438272
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5001,
    cy: 35.4998,
    r: 28.7068,
    fill: "url(#paint2_linear_684_3215)",
    fillOpacity: 0.5,
    stroke: "url(#paint3_linear_684_3215)",
    strokeWidth: 0.438272
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0667 44.2667L39.9667 36H34.6334L35.6001 28.4334L29.4334 37.3334H34.0667L33.0667 44.2667ZM31.2054 47.8467L32.5387 38.6667H26.8721L36.8454 24.2827H37.4614L36.1547 34.6667H42.8214L31.8214 47.8467H31.2054Z",
    fill: "#98A2B3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_684_3215",
    x1: 35.5,
    y1: 3.28704,
    x2: 35.7772,
    y2: 104.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#299E47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300199,
    stopColor: "#299E47",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#299E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_684_3215",
    x1: 35.5,
    y1: 0,
    x2: 35.5,
    y2: 87.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A2B3",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41464D",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_684_3215",
    x1: 35.5001,
    y1: 6.57385,
    x2: 36.6752,
    y2: 98.3831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F9F4",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356773,
    stopColor: "#FAFFFB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F9F3",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_684_3215",
    x1: 35.5001,
    y1: 6.57385,
    x2: 35.5001,
    y2: 64.4257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475467",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA7CD",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltIcon);
export default __webpack_public_path__ + "static/media/boltIcon.44acc5f5c9b862c88d80a58de2ea071d.svg";
export { ForwardRef as ReactComponent };